import * as React from "react";

function ToggleState2() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10">
    <g id="State_2_-_Basic_Panel" data-name="State 2 - Basic Panel" transform="translate(-61 -489)">
      <g id="Group_54797" data-name="Group 54797" transform="translate(-161 -178)">
        <rect id="Rectangle_10699" data-name="Rectangle 10699" width="18" height="10" rx="5" transform="translate(222 667)" fill="#939393"/>
      </g>
      <circle id="Ellipse_2315" data-name="Ellipse 2315" cx="3" cy="3" r="3" transform="translate(71 491)" fill="#fff"/>
    </g>
  </svg>
  
  );
}

export default ToggleState2;